export const getListOfWorkStatusAction = (state = [], action) => {
  switch (action.type) {
    case "LIST_OF_WORK_STATUS":
      return action.data;

    default:
      return state;
  }
};
